import { motion } from 'framer-motion';

import { Box, BoxProps } from '@vimeo/bokeh';

import { SHIMMER_GRADIENT } from '../../constants';

const MotionGradient = ({ maxWidth, bgOffset = 0 }: { maxWidth: number; bgOffset: number }) => (
  <motion.div
    style={{
      width: maxWidth,
      height: '200%',
      opacity: '100%',
      borderRadius: 'inherit',
      position: 'relative',
      bottom: '50%',
      filter: `blur(16px)`,
    }}
    initial={{
      left: -(maxWidth * 1.5 - bgOffset),
    }}
    animate={{
      left: maxWidth * 1.5 + bgOffset,
      opacity: [0, 0.3, 0.7, 0.5, 0.1, 0],
      transition: {
        duration: 2,
        repeatType: 'loop',
        ease: 'linear',
        repeat: Infinity,
      },
    }}
  >
    <Box w="200%" h="200%" bg={SHIMMER_GRADIENT} />
  </motion.div>
);

interface ShimmeringPlaceholderProps {
  maxWidth?: number;
  bgOffset?: number;
}

export const ShimmeringPlaceholder = ({ ...props }: BoxProps & ShimmeringPlaceholderProps) => {
  return (
    <Box borderRadius={'8px'} bg="background-blur" overflow="hidden" {...props}>
      {props.maxWidth && props.bgOffset && (
        <MotionGradient maxWidth={props.maxWidth} bgOffset={props.bgOffset} />
      )}
    </Box>
  );
};
